package com.essntl.features.proposal.data.supabase.proposal

import com.essntl.features.proposal.domain.model.ProposalModel
import core.dateformat.utils.fromDDTOMM
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive
import kotlin.math.max

internal fun ProposalModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    if (title != null) {
        requestMap["title"] = JsonPrimitive(title)
    }

    if (proposalId != null) {
        requestMap["proposal_id"] = JsonPrimitive(proposalId)
    }

    if (headline != null) {
        requestMap["headline"] = JsonPrimitive(headline)
    }

    if (areas != null) {
        requestMap["areas"] = JsonArray(areas!!.map { JsonPrimitive(it) })
    }

    fromDate?.let {
        requestMap["from_date"] = JsonPrimitive(fromDDTOMM(it))
    }

    toDate?.let {
        requestMap["to_date"] = JsonPrimitive(fromDDTOMM(it))
    }

    if (requestId != null) {
        requestMap["request_id"] = JsonPrimitive(requestId)
    }

    if (itineraryId != null) {
        requestMap["itinerary_id"] = JsonPrimitive(itineraryId)
    }

    if (primaryClient != null) {
        primaryClient?.id?.let {
            requestMap["primary_client"] = JsonPrimitive(it.ifBlank { null })
        }
    }

    if (clients != null) {
        requestMap["clients"] = JsonArray(clients!!.map { JsonPrimitive(it) })
    }

    if (guestCount != -1) {
        requestMap["guest_count"] = JsonPrimitive(max(1, guestCount))
    }

    if (owner != null) {
        requestMap["owner_id"] = JsonPrimitive(owner?.id)
    }

    coverImage?.let {
        requestMap["cover_image"] = JsonPrimitive(it.id.ifBlank { null })
    }

    status?.let {
        requestMap["status"] = JsonPrimitive(it.toDto())
    }

    shareCode?.let {
        requestMap["share_code"] = JsonPrimitive(it.ifBlank { null })
    }

    guestDetails?.let {
        requestMap["guest_details"] = JsonPrimitive(it.ifBlank { null })
    }

    statusUpdatedAt?.let {
        requestMap["status_updated_at"] = JsonPrimitive(it.ifBlank { null })
    }

    requestReceivedDate?.let {
        requestMap["request_received_date"] = JsonPrimitive(fromDDTOMM(it).ifBlank { null })
    }

    if (travelAgent != null) {
        requestMap["travel_agent_id"] = JsonPrimitive(travelAgent?.id)
    }

    commission?.let { requestMap["agent_comm"] = JsonPrimitive(it) }
    hidePrices?.let { requestMap["hide_prices"] = JsonPrimitive(hidePrices) }
    showsTotalOnly?.let { requestMap["shows_total_only"] = JsonPrimitive(showsTotalOnly) }
    hideBranding?.let { requestMap["hide_branding"] = JsonPrimitive(hideBranding) }

    return requestMap
}